import { useEffect, useState } from 'react';
// Style
import Login from './components/Login';
import OTP from './components/OTP';
import Register from './components/Register';
import { Center, Stack } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { authActions } from '../../_store/auth/auth.slice';
import { IRedux, IUser } from '../../_store/types';
import {
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogHeader,
  DialogRoot,
} from '@/components/ui/dialog';
import Logo from '../Logo';
import useGTM from '../../_hooks/useGTM';
import { useTelegram } from '../../_providers/telegram';
import { track } from '../../_utils/utm';

const initialValues = { phone: '', name: '' };

function AuthDesktop({
  open = false,
  onClose,
  onLastConfirm = () => {},
}: {
  open: boolean;
  onClose: () => void;
  onLastConfirm: (data: IUser) => void;
}) {
  const [formData, setFormData] = useState(initialValues);

  const [otp, setOTP] = useState('');
  const [activeWindow, setActiveWindow] = useState('login');
  const { user } = useSelector((state: IRedux) => state.auth);

  useEffect(() => {
    if (open && otp) {
      setOTP('');
    }
  }, [activeWindow]);

  useEffect(() => {
    if (open) {
      setActiveWindow('login');
    }
  }, [open]);

  const onChange = (name: string, value: string) =>
    setFormData((prev) => ({ ...prev, [name]: value }));
  let isCheck =
    activeWindow === 'register' && user?.name === 'Новый пользователь';

  return (
    <>
      <DialogRoot
        placement={'center'}
        lazyMount
        open={open}
        onOpenChange={() => (isCheck ? () => {} : onClose())}
      >
        <DialogContent
          maxW='480px'
          rounded={12}
          bg='background.card'
          color='text'
        >
          <DialogHeader p={6} pb={4}>
            <Center>
              <Logo />
            </Center>
          </DialogHeader>
          <DialogBody>
            <Stack
              flex={1}
              // minH={activeWindow === 'register' ? 'fit-content' : '250px'}
            >
              <ActiveWindow
                activeWindow={activeWindow}
                onClose={onClose}
                formData={formData}
                onChange={onChange}
                onLastConfirm={(data) => {
                  onLastConfirm(data);
                  setFormData(initialValues);
                }}
                setActiveWindow={setActiveWindow}
              />
            </Stack>
          </DialogBody>

          <DialogCloseTrigger color={'text.muted'} />
        </DialogContent>
      </DialogRoot>
    </>
  );
}

function ActiveWindow({
  activeWindow,
  onClose,
  formData,
  onChange,
  onLastConfirm,
  setActiveWindow,
}: {
  activeWindow: string;
  onClose: () => void;
  formData: typeof initialValues;
  onChange: (name: string, value: string) => void;
  onLastConfirm: (e: IUser) => void;
  setActiveWindow: React.Dispatch<React.SetStateAction<string>>;
}) {
  const dispatch = useDispatch();
  const { sendGTM } = useGTM();
  const { tg_chat_id } = useTelegram();

  const trackRegister = async ({ customer_id }: Record<string, string>) => {
    try {
      await track({
        action_type: 'register',
        customer_id,
        tg_chat_id,
      });
    } catch (error) {
      console.log(error);
    }
  };

  if (activeWindow === 'register') {
    return (
      <Register
        formData={formData}
        setActiveWindow={setActiveWindow}
        onSuccess={(data) => {
          dispatch(authActions.setUser(data));
          trackRegister({ customer_id: data?.id });
          onLastConfirm(data);
          onClose();
          if (window.dataLayer) {
            window?.dataLayer.push({
              event: 'Authorization_successful',
            });
          }
        }}
      />
    );
  } else if (activeWindow === 'login') {
    return (
      <Login
        values={formData}
        onChange={onChange}
        onSuccess={(data) => {
          dispatch(authActions.setUser(data));
          sendGTM('login_success', {});
          onLastConfirm(data);
          onClose();
        }}
        setActiveWindow={setActiveWindow}
      />
    );
  } else {
    return (
      <OTP
        phoneNumber={formData.phone}
        onSuccess={(data) => {
          dispatch(authActions.setUser(data));
          sendGTM('login_success', {});
          onLastConfirm(data);
          onClose();
        }}
        backToLogin={() => setActiveWindow('login')}
        isRegister={activeWindow === 'register-confirmation'}
      />
    );
  }
}

export default AuthDesktop;
